<template>
  <div>
    <div class="content-wrapper exhibition">
      <section class="cw-section ex-info">
        <div class="pic"><img :data-src="info.imageUrl | imageUrl" :class="info.imageUrl | imageClass(info.imageWidth, info.imageHeight, 0.73)" :src="info.imageUrl | imageUrl('?imageView2/1/w/496/h/680')" /></div>
        <div class="content">
          <h1>{{info.name}}</h1>
          <dl v-if="info.exStartTime">
            <dt>时间：</dt>
            <dd>{{info.exStartTime | formatDate}} - {{info.exEndTime | formatDate}}</dd>
          </dl>
          <dl v-if="info.openTime">
            <dt>开放时间：</dt>
            <dd>{{info.openTime}}</dd>
          </dl>
          <dl v-if="info.pavilion">
            <dt>地址：</dt>
            <dd>{{info.pavilion}}<br>{{info.exAddress}}
              <a class="local" :href="`https://map.baidu.com/?latlng=${info.bLat},${info.bLng}&title=${info.pavilion}&content=${info.exAddress}&autoOpen=true`" target="_blank">去这里</a>
            </dd>
          </dl>
          <dl v-if="info.ticketSubject">
            <dt>费用：</dt>
            <dd>{{info.ticketSubject}}</dd>
          </dl>
          <a :href="shareUrl" class="buy-ticket-btn" v-if="hasTicket">去购票</a>
        </div>
      </section>
      <section class="cw-section detail">
        <div class="hd cw-hd">
          <h2 class="title">展览详情</h2>
        </div>
        <div class="bd" v-html="subject"></div>
      </section>
      <section class="cw-section" v-if="recommend.length">
        <div class="hd cw-hd">
          <h2 class="title">相关展览推荐</h2>
        </div>
        <div class="bd related-list">
          <exhibitionList :datas="recommend"></exhibitionList>
        </div>
      </section>
    </div>
    <appbar></appbar>
  </div>
</template>
<script>
import appbar from '../common/appbar'
import exhibitionList from '../common/exhibitionList'
import { getExhibitionDetail } from '@/api/zaiart'
import { resolveContent } from '@/utils/filters'
export default {
  components: { exhibitionList, appbar },
  data() {
    return {
      pageId: null,
      info: {},
      recommend: [],
      hasTicket: false
    }
  },
  computed: {
    subject() {
      // resolveContent(value, maxWidth)
      return resolveContent(this.info.subject, '1024')
    },
    shareUrl() {
      return `${process.env.VUE_APP_SHARE_WEB_URL}/show.html?id=${this.pageId}`
    }
  },
  methods: {
    init() {
      this.getDetailData()
    },
    getDetailData() {
      const param = { id: this.pageId }
      return getExhibitionDetail(param).then(response => {
        this.info = response.data.info
        this.recommend =
          (response.data.recommend && response.data.recommend.datas) || []
        // 售票状态
        let nowTs = +new Date()
        if (
          this.info.hasTicket &&
          nowTs > this.info.ticketStartTime &&
          nowTs < this.info.ticketEndTime
        ) {
          this.hasTicket = true
        }
      })
    }
  },
  created() {
    this.pageId = this.$route.params.id
    this.init()
  }
}
</script>
<style>
.buy-ticket-btn {
  margin: 8px 0;
  display: inline-block;
  width: 116px;
  height: 40px;
  line-height: 40px;
  color: #fff;
  text-align: center;
  background-color: #0650ff;
  border-radius: 4px;
}
.exhibition .ex-info {
  margin-top: 40px;
  overflow: hidden;
}
.exhibition .ex-info .pic {
  position: relative;
  float: left;
  width: 248px;
  height: 340px;
  overflow: hidden;
}
.exhibition .ex-info .content {
  margin-left: 284px;
}
.exhibition .ex-info .content h1 {
  margin-top: 25px;
  margin-bottom: 30px;
  font-size: 28px;
  font-weight: normal;
  line-height: 44px;
  color: #333;
  padding-bottom: 16px;
  border-bottom: 1px dashed #dadada;
}
.exhibition .ex-info .content dl {
  overflow: hidden;
}
.exhibition .ex-info .content dt {
  float: left;
  width: 90px;
  font-size: 16px;
  line-height: 30px;
  color: #999;
}
.exhibition .ex-info .content dd {
  margin-left: 90px;
  font-size: 16px;
  line-height: 30px;
  color: #666;
}
.exhibition .ex-info .content .local {
  display: inline-block;
  margin-left: 10px;
  padding-left: 16px;
  background: url('../../../assets/img/icon/local.png') no-repeat left center;
  background-size: 11px 14px;
  color: #1e88f5;
}
.exhibition .detail {
  font-size: 16px;
  color: #333;
  line-height: 28px;
}
.exhibition .detail p:first-child {
  margin-top: 0 !important;
}
.exhibition .detail p {
  font-size: 16px;
  line-height: 28px;
  margin-bottom: 20px;
}
.exhibition .detail p:last-child {
  margin-bottom: 0;
}
.exhibition .detail img {
  max-width: 100%;
}
.exhibition .related-list {
  margin-right: -21px;
  overflow: hidden;
}
</style>
